import { Modal, useTheme, IconButton, Box } from '@mui/material';
import { ReactNode } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';

interface IProps {
  open: boolean;
  handleClose: () => void;
  children: ReactNode;
  sx?: object;
  ariaLabel: string;
  closeOnParentClick?: boolean;
  showCloseButton?: boolean;
  hide?: boolean;
  keepMounted?: boolean;
}

export const CustomModal = ({
  open,
  handleClose,
  children,
  sx,
  ariaLabel,
  closeOnParentClick = false,
  showCloseButton = false,
  hide = false,
  keepMounted = false
}: IProps) => {
  const theme = useTheme();

  return (
    <Modal id="index__components-modal__modal__l31"
    open={open}
    onClose={handleClose}
    aria-labelledby={`${ariaLabel}-title`}
    aria-describedby={`${ariaLabel}-description`}
    keepMounted={keepMounted}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 100000,
      visibility: hide ? 'hidden' : 'visible'
    }}>
      
      <Box id="index__components-modal__box__l45"
      onClick={(e) => {
        if (closeOnParentClick) {
          e.stopPropagation();
          handleClose();
        }
      }}
      sx={{
        outline: 'none',
        ...sx
      }}>
        
        {/* Close Button in the Backdrop Area */}
        {showCloseButton &&
        <IconButton id="index__components-modal__iconbutton__l59"
        onClick={handleClose}
        sx={{
          position: 'fixed',
          top: 4,
          right: 8,
          zIndex: 100,
          color: theme.palette.grey[50]
        }}>
          
            <CloseIcon />
          </IconButton>
        }

        {children}
      </Box>
    </Modal>);

};